<template>
  <a-layout class='index animated fadeIn'>
    <SmallSquare content='用户授权访问即视为最低等级会员' :padding='true'></SmallSquare>
    <a-card :bordered='false'>
      <a-form ref='form' :model='search' :style="{'marginBottom':'10px'}" :initialValues="search"
        :onFinish='pageSearchChange' layout='inline'>
        <a-form-item label="" class='mb15' name='keyword'>
          <a-input-group compact :style="{width:'360px'}">
            <a-select v-model:value="search.type" style="width: 30%" @change="inputSelect">
              <a-select-option value="member_name">微信昵称</a-select-option>
              <a-select-option value="member_id">用户ID</a-select-option>
              <a-select-option value="mobile">手机号</a-select-option>
              <a-select-option value="openid">openID</a-select-option>
            </a-select>
            <a-input style="width: 70%" v-model:value="search.keyword" placeholder="请输入关键词进行搜索" />
          </a-input-group>
        </a-form-item>
        <a-form-item label="微信状态" name='is_sub'>
          <a-select v-model:value="search.is_sub" :style="{width:'180px'}" placeholder="全部">
            <a-select-option value="">
              全部
            </a-select-option>
            <a-select-option value="0">
              未关注
            </a-select-option>
            <a-select-option value="1">
              已关注
            </a-select-option>
            <a-select-option value="2">
              已跑路
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="排序" name='sort_type'>
          <a-select v-model:value="search.sort_type" :style="{width:'180px'}">
            <a-select-option :value="0">默认排序</a-select-option>
             <a-select-option :value="3">
              可用积分降序
            </a-select-option>
             <a-select-option :value="4">
              可用积分升序
            </a-select-option>
             <a-select-option :value="5">
              扫码个数降序
            </a-select-option>
             <a-select-option :value="6">
              扫码个数升序
            </a-select-option>
            <a-select-option :value="7">
              当前红包降序
            </a-select-option>
            <a-select-option :value="8">
              当前红包升序
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="注册时间" name='time'>
          <a-range-picker v-model:value="search.time" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD'
            @change="changTime" />
        </a-form-item>
        <!-- <a-form-item label="客户标签" name='level'>
          <a-select v-model:value="search.level" :style="{width:'180px'}" placeholder="全部">
            <a-select-option value="shanghai">
              全部
            </a-select-option>
          </a-select>
        </a-form-item> -->
        <a-form-item label="所在地区" name='region'>
          <selectCity v-model:value="search.region" placeholder="所在地区" />
        </a-form-item>
        <a-form-item label="会员等级" name='level'>
          <a-select v-model:value="search.level" :style="{width:'180px'}">
            <a-select-option value="">全部</a-select-option>
            <a-select-option v-for='item in vipList' :key='item.vip_number' :value="item.vip_number">{{item.vip_name}}
            </a-select-option>
          </a-select>
        </a-form-item>
        <!--  -->
         <a-form-item label="会员标签" name='level'>
          <a-select v-model:value="search.tag_id" :style="{width:'180px'}">
            <a-select-option value="">全部</a-select-option>
            <a-select-option v-for='item in tagsList' :key='item.id' :value="item.id">{{item.tag_name}}
            </a-select-option>
          </a-select>
        </a-form-item>
         <a-form-item label="所属门店">
           <a-input  v-model:value="search.store_name" placeholder="请输入所属门店名称" />
         </a-form-item>
        <!--  -->
        <a-form-item>
          <a-button type="primary" htmlType='submit' class='m-r-10'>搜索</a-button>
          <a-button class='m-r-10' v-has:membersExport="exportTable">导出</a-button>
     
        </a-form-item>
      </a-form>
      <div class='m-t-20'>
              <!--  -->
      <!-- <a-tabs v-model:activeKey="search.member_type" @change="changeTab">
        <a-tab-pane :key="1" tab="门店用户"></a-tab-pane>
        <a-tab-pane :key="2" tab="总部用户"></a-tab-pane>
        <a-tab-pane :key="3" tab="VIP用户"></a-tab-pane>
      </a-tabs> -->
      <!--  -->
        <a-table :pagination='false' :loading='listLoading' bordered rowKey='member_id' :columns='columns'
          :data-source='data'>
          <template v-slot:store="{ record }">
            <p v-if='record.store_info.store_belong'>
              {{record.store_info.store_name}}<br>
              ( {{record.store_info.store_belong_name}} )
            </p>
            <p v-else>-</p>
          </template>
          <template v-slot:point="{ record }">
            <a href="javascript:;" v-has:userPointLog="()=>{showPointList=record.point?true:false;listItem=record}">{{record.point}}</a>
          </template>
          <template v-slot:bonus="{ record }">
            <a href="javascript:;" v-has:userRedLog="()=>{showRedList=record.bonus?true:false;listItem=record}">{{record.bonus}}</a>
          </template>
          <template v-slot:action="{ record }">
            <a-dropdown>
              <a class="ant-dropdown-link"> 操作
                <DownOutlined />
              </a>
              <template v-slot:overlay>
                <a-menu>
                  <a-menu-item>
                    <a v-has:membersDetail="()=>userDetail(record,'edit')" href="javascript:;">详情</a>
                  </a-menu-item>
                  <a-menu-item>
                    <a v-has:membersAddPoint="()=>{showIntegral = true;listItem=record;integral='';integralRemarks=''}" href="javascript:;">送积分</a>
                  </a-menu-item>
                  <a-menu-item>
                    <a v-has:userAddCoupon="()=>{showCoupon = true;listItem=record;}" href="javascript:;">派券</a>
                  </a-menu-item>
                   <a-menu-item>
                    <a v-has:userAddGrowth="()=>getGrowth(record)" href="javascript:;">赠送成长值</a>
                  </a-menu-item>
                  <a-menu-item v-if='record.store_info.store_belong'>
                    <a href="javascript:;" v-has:userDelStore="()=>unbundling(record)">解绑</a>
                  </a-menu-item>
                </a-menu>
              </template>
            </a-dropdown>
          </template>
        </a-table>
        <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper
          :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange"
          @showSizeChange="pageSizeChange"  :show-total="total => `共 ${total} 条`" />
      </div>
    </a-card>
  </a-layout>
  <!-- 充值积分 -->
  <a-modal  :keyboard="false" title="充值积分" centered v-model:visible="showIntegral" :confirm-loading="confirmLoading" @ok="eidtIntegral"
    destroyOnClose>
    <a-form-item name='' label='积分' help='可输入负数（负数为扣除积分）' :wrapper-col="{ span: 20, offset: 1 }">
      <a-input-number class="width100" v-model:value="integral" placeholder="请输入积分数" />
    </a-form-item>
    <a-form-item name='' label='备注' :wrapper-col="{ span: 20, offset: 1 }">
      <a-textarea v-model:value="integralRemarks" placeholder="如备注发放/扣除积分的原因，方便稽查" :rows="4" />
    </a-form-item>
  </a-modal>
  <a-modal  :keyboard="false" title="派券" centered v-model:visible="showCoupon" :footer='null' destroyOnClose>
    <addCoupon v-on:onsubmit="onsubmit" :id='listItem.member_id'></addCoupon>
  </a-modal>
  <!-- 成长值 -->
  <a-modal  :keyboard="false" title="赠送成长值" centered v-model:visible="showGrowth"  destroyOnClose @Cancel="()=>{growthValue=''}" @Ok="postAddExp">
    <a-form-item name='' label='当前成长值：' :labelCol="{span:6}">
        <div>{{listItem.userExp}}</div>
    </a-form-item>
    <a-form-item name='' label='赠送成长值 ' :labelCol="{span:6}" :wrapper-col="{ span: 14 }" :help="`最多能赠送 ${listItem.needExp} 成长值，保存后将根据新的总成长值更新会员等级信息`">
       <a-input-number class="width100" v-model:value="growthValue" placeholder="请输入成长值" v-inputFilter:maxExp="{max:listItem.needExp}"/>
    </a-form-item>
  </a-modal>
  <!-- 积分明细 -->
  <a-modal  :keyboard="false" title="积分明细" centered v-model:visible="showPointList" :width='1300' :footer="null" destroyOnClose>
    <pointsList :id='listItem.member_id'></pointsList>
  </a-modal>
  <!-- 红包明细 -->
  <a-modal  :keyboard="false" title="红包明细" centered v-model:visible="showRedList" :width='1300' :footer="null" destroyOnClose>
    <redLog :id='listItem.member_id'></redLog>
  </a-modal>
</template>
<script>
  import { DownOutlined } from "@ant-design/icons-vue";
  import { reactive, ref, toRefs, onMounted, inject,h } from "vue";
  import { message } from "ant-design-vue";
  import { iscode } from "@/utils/app";
  import { getMemberList, getMemberTagList, getMemberVip, setMemberUnbind, addUserPoint,getMemberNeedExp,postMemberAddExp } from '@/api/member'
  import addCoupon from './components/addCoupon.vue';
  import pointsList from './components/list.vue';
  import redLog from './components/redLog.vue';
  const def = {
    page: 1,
    limit: 10,
    type: 'member_name',
    keyword: '',
    is_sub: '',
    register_start_time: '',
    register_end_time: '',
    region: '',
    sort_type: 0,
    level: '',
    tag_id:'', //标签
    store_name:'',
  }
  let time=null;
  export default {
    components: { DownOutlined,addCoupon,pointsList,redLog },
    name: "integralDetail",
    setup() {
      const state = reactive({
        showCoupon:false,
        vipList: [],
        listLoading: false,
        total: 0,
        visible: false,
        showIntegral: false,
        confirmLoading: false,
        listItem: {},
        integral: '',
        integralRemarks: '',
        showGrowth:false,//赠送成长值
        growthValue:'',
        tagsList:[],
        showPointList:false,//积分明细
        showRedList:false,//红包明细
      });
      let data = ref();
      let columns = [
        {
          title: "会员ID",
          dataIndex: "member_id",
          key: "member_id",
        },
        {
          title: "微信昵称",
          dataIndex: "member_name",
          key: "member_name",
          // customRender: ({ record }) => {
          //   return record.member_name ? record.member_name : '-'
          // },
          customRender:function({record}){
            return h('div',{
              style:{
                'display':'flex',
                'align-items':'center',
                'height':'60px',
                 
              }
            },[h('img',{
              src:record.headimgurl || require('@/assets/images/normal.png'),
              style:{
                 'width':"60px",
                 'height':'60px',
                 'marginRight':'20px'
              }
            },''),record.member_name || ''])
          }
        },
        {
          title: "会员等级",
          dataIndex: "vip_level_name",
          key: "vip_level_name",
        },
        {
          title: "所属门店",
          dataIndex: "store",
          key: "store",
          slots: { customRender: "store" },
        },
        {
          title: "可用积分",
          dataIndex: "point",
          key: "point",
          slots: { customRender: "point" },
        },
        {
          title:'当前红包',
          dataIndex:'bonus',
          slots: { customRender: "bonus" },
        },
        {
          title:'扫码个数',
          dataIndex:'scan'
        },
        {
          title: "手机号码",
          dataIndex: "phone",
          key: "phone",
          customRender: ({ record }) => {
            return record.mobile ? record.mobile : '-'
          },
        },
        {
          title: "操作",
          key: "action",
          width: 120,
          slots: { customRender: "action" },
        }
      ];
      //获取列表
      const initData = async (values) => {
        state.listLoading = true;
        let res = await getMemberList({
          ...values,
          region:values.region.length?values.region[values.region.length-1]:''
        }).then((res) => res.data);
        if (iscode(res)) {
          data.value = res.data.list;
          state.total = res.data.total;
        }
        state.listLoading = false;
      };
      const $Modal = inject('$Modal')
      //送积分
      const eidtIntegral = async () => {
        if (!state.integral) {
          message.error('请输入积分！');
          return
        }
        state.confirmLoading = true
        let res = await addUserPoint({ remark: state.integralRemarks, member_id: state.listItem.member_id, point: state.integral }).then((res) => res.data).catch(error => error);
        if (iscode(res)) {
          state.showIntegral = false
          message.success(res.msg);
          initData(search.value)
        } else {
          message.error(res.msg);
        }
        state.confirmLoading = false
      }
      //派券
      const onsubmit = () =>{
        state.showCoupon = false
        initData(search.value);
      }
      //解绑
      const unbundling = (e) => {
        $Modal.confirm({
          centered: true,
          title: '会员解绑',
          content: '您确定要解绑该会员吗？', onOk: async () => {
            let res = await setMemberUnbind(e.member_id).then(res => res.data);
            if (iscode(res)) {
              message.success(res.msg);
              initData(search.value);
            } else {
              message.error(res.msg);
            }
          }
        })
      }
      //获取标签
      const getTag = async () => {
        let res = await getMemberTagList({limit:99}).then((res) => res.data);
        if (iscode(res)) {
          state.tagsList = res.data.data;
        }
      };
      //获取会员等级
      const getVip = async () => {
        let res = await getMemberVip().then((res) => res.data);
        if (iscode(res)) {
          state.vipList = res.data;
        }
      };
      const search = ref({...def});
      // 页面筛选项搜索
      const pageSearchChange = () => {
        search.value = { ...search.value, page: 1 };
        initData(search.value);
      };
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
      const changTime = (e) => {
        search.value.register_start_time = e[0]
        search.value.register_end_time = e[1]
      }
      const inputSelect = (e) => {
        search.value.keyword = ''
      }
      onMounted(() => {
        if ($route.query.vip_number) {
          search.value.level = Number($route.query.vip_number)
        } else {
          search.value.level = ''
        }
        getVip();
        getTag()
        initData(search.value);
      });
      const $router = inject('$router')
      const $route = inject('$route')
      const userDetail = (data) => {
        $router.push({ path: '/members/memberList/userDetail', query: { member_id: data.member_id } })
      }
    // 导出
    const exportTable=async ()=>{
        let res = await getMemberList({...search.value,excel:1}).then(res=>res.data);
        if(iscode(res,true)){
          window.open(res.data.action)
        }
    }
    
    //获取成长值
    const getGrowth = async function(data){
       let res = await getMemberNeedExp({uid:data.member_id}).then(res=>res.data);
       if(iscode(res)){
         state.listItem=res.data;
         state.listItem.member_id = data.member_id;
          state.showGrowth = true;
       }else{
         message.error(res.msg);
       }
    }

    //添加成长值
    const postAddExp = async function(){
       const hide = message.loading("正在加载中...", 0);
       let res = await postMemberAddExp({exp:state.growthValue,uid:state.listItem.member_id}).then(res=>res.data);
        setTimeout(hide);
       if(iscode(res)){
         message.success(res.msg)
         state.showGrowth = false;
         initData(search.value);
       }else{
         message.error(res.msg);
       }
    }

    const changeTab = (e)=>{
      search.value.page = 1;
      search.value.limit = 10;
       data.value = []
      initData(search.value);
    }


      return {
        ...toRefs(state),
        search,
        data,
        columns,
        pageSearchChange,
        pageCurrentChange,
        pageSizeChange,
        changTime,
        inputSelect,
        userDetail,
        unbundling,
        eidtIntegral,
        onsubmit,
        exportTable,
        getGrowth,
        postAddExp,
        changeTab
      };
    },
  };
</script>